import { render, staticRenderFns } from "./SmallHotelItinerary.vue?vue&type=template&id=0b479940&scoped=true&"
import script from "./SmallHotelItinerary.vue?vue&type=script&lang=js&"
export * from "./SmallHotelItinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b479940",
  null
  
)

export default component.exports